import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { SearchQuestionBottomPanel } from './SearchQuestionBottomPanel.component'

const withUnmountHoc = withUnmountTransition(SearchQuestionBottomPanel)
export { withUnmountHoc as SearchQuestionBottomPanel }
